// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkbox-module__wrapper--uxovJ{flex-shrink:0;align-items:center;display:flex}.Checkbox-module__wrapper--uxovJ>:hover{cursor:pointer}.Checkbox-module__svg--wyhcI{color:#09c;width:1rem;min-width:1rem;height:1rem;min-height:1rem}.Checkbox-module__label--oaFoy{margin-left:.375rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Checkbox-module__wrapper--uxovJ`,
	"svg": `Checkbox-module__svg--wyhcI`,
	"label": `Checkbox-module__label--oaFoy`
};
export default ___CSS_LOADER_EXPORT___;
